export default __webpack_public_path__ + "static/media/(55).a16b4904.jpg";